<template>
  <div>
    <div class="bsod container">
      <h1 class="neg title"><span class="bg">KIZI404 - NOT FOUND</span></h1>
      <div :class="{ toHidden: hidden, item: displayNone }">
        <p>
          The crew you attempted to reach is missing or never existed.<br />
          You can wait and see if it becomes available, or you can restart your
          computer. <br />
          The current HTTP session will be terminated.
        </p>
        <p>
          * Return to your homepage.<br />
          * Look for something that exists.
        </p>
        <p class="any-key" v-if="!isMobile">
          Press any key to abort process<span class="blink">_</span>
        </p>
        <p class="any-key" v-else>
          Touch anywhere to abort process<span class="blink">_</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { delay } from "@/variables.js";
import MainMixinVue from "./utilities/MainMixin.vue";
export default {
  name: "WelcomePage",
  title: "Not Found",
  mixins: [MainMixinVue],
  data() {
    return {
      hidden: false,
      displayNone: false,
      animateOnce: false,
    };
  },
  methods: {
    animatePassword() {
      this.hidden = true;
      delay(1200).then(() => {
        this.displayNone = true;
        delay(1000).then(() => {
          this.$router.push("/passworld");
        });
      });
    },
    launchAnimation() {
      if (this.animateOnce == false) {
        this.animateOnce = true;
        this.animatePassword();
      }
    },
  },
  mounted() {
    if (this.isMobile) {
      this.resetZoomMobile();
      window.addEventListener("touchend", this.launchAnimation);
    } else {
      window.addEventListener("keyup", this.launchAnimation);
    }
  },
  beforeDestroy() {
    if (this.isMobile) {
      window.removeEventListener("touchend", this.launchAnimation);
    } else {
      window.removeEventListener("keyup", this.launchAnimation);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/landing-error.scss";

@media screen and (max-width: 750px) {
  p {
    text-align: center;
  }
}
</style>
